import Drawer from '../../components/Drawer';

import FormAssociarUsuario from './FormAssociarUsuario';

interface Props {
  open: boolean;
  onClose: () => void;
}

const DrawerAssociarUsuario = ({ open, onClose }: Props) => {
  return (
    <Drawer
      title="Associar conta"
      subtitle="Informe o CPF para localizar ou preencher os dados do cliente e associar à conta."
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: '100%', sm: 680 }, maxWidth: '100vw' } }}
    >
      <FormAssociarUsuario onClose={onClose} />
    </Drawer>
  );
};

export default DrawerAssociarUsuario;
